import { Controller } from "@hotwired/stimulus"
import { reportErrorToNewRelic } from "../helpers"

export default class extends Controller {
    static targets = ["latitude", "longitude", "accuracy"]

    connect() {
        this.locate()
    }

    get isSupported() {
        return ('geolocation' in navigator) && this.hasAllTargets;
    }

    get hasAllTargets() {
        const result = this.hasLatitudeTarget && this.hasLongitudeTarget && this.hasAccuracyTarget;

        if (!result) {
            console.warn("WARNING not all targets are present")
        }

        return result;
    }

    get error() {
        return function (err) {
            console.warn(`ERROR locating user (${err.code}): ${err.message}`);
            reportErrorToNewRelic(err)
        }
    }

    get options() {
        return {
            enableHighAccuracy: false,
            timeout: 5000,
            maximumAge: 0
        }
    }

    locate() {
        if (!this.isSupported) return;

        const success = (position) => {
            var coordinates = position.coords;

            this.latitudeTarget.value = coordinates.latitude
            this.longitudeTarget.value = coordinates.longitude
            this.accuracyTarget.value = coordinates.accuracy
        }

        navigator.geolocation.getCurrentPosition(success, this.error, this.options);
    }
}